import React, {useEffect, useRef, useState} from 'react';
import { useT } from '../helpers/i18n';
import { useInViewport } from 'react-in-viewport';
import Skeleton from 'react-loading-skeleton';
import { faRoute as farRoute } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Checkers from '../helpers/class/Checkers';

import ModalPois from './templates/property/partials/modals/ModalPois';
import CustomModal from './CustomModal';
import GoogleMapContent from './GoogleMapContent';

export default function GoogleMapSection ( props ) {
  const t = useT();

    const container = props.container != undefined ? props.container : 'container'

    const hidePin = props.hasOwnProperty('hidePin') ? props.hidePin : false

    const randomizePin = props.app.builder.builder_propertylist_map_enable_randomize_pin

    const config = {disconnectOnLeave: false};
    const options = {};
    const myRef = useRef();
    const {
        inViewport
    } = useInViewport(
        myRef,
        options,
        config,
        props
    );

    const property_lat = props.property_lat;
    const property_lng = props.property_lng;
    const googleMapShow = props.googleMapShow;
    const googleMapApiKey = props.googleMapApiKey;
    const hasGoogleMapApiKey = Checkers.isValidString(googleMapApiKey);

    const position = {
        lat: parseFloat(property_lat),
        lng: parseFloat(property_lng),
    };
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const viewPortResult = [];
    if (!inViewport) {
        viewPortResult[0] =
            <Skeleton style={{flexGrow: "1", height: "100%", background: "#f5f5f5"}}/>
        ;
        viewPortResult[1] =
            <Skeleton style={{flexGrow: "1", height: "100%", background: "#f5f5f5"}}/>
        ;
    } else {
        viewPortResult[0] = hasGoogleMapApiKey ?
            <GoogleMapContent app={props.app} map_pois={props.map_pois} center={position}
                              randomizePin={randomizePin}
                              hidePin={hidePin}
                              propertyTitle={props.propertyTitle}
                              propertyImages={props.propertyImages}
                              propertyAddress={props.propertyAddress}
                              googleMapApiKey={googleMapApiKey} inViewport={inViewport}/>
            :
            <iframe
                title="google maps"
                src={`https://maps.google.com/maps?q=${property_lat},${property_lng}&z=14&output=embed`}
                width="600"
                height="364"
                style={{border: 0, width: '100%', height: '100%'}}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
            />
        ;
        viewPortResult[1] =
            (props.map_pois.length > 0 || Checkers.isValidObjString(props, 'descAreaDistances')) &&
            <section className="bg-master-lightest pb-5">
                <div className={container + " p-0 bg-master-lightest position-relative top-0 d-block h-auto p-t-0"}>
                    <div className="bg-design-color row justify-content-center w-100 m-0">
                        <div className="col-8 col-sm-6 py-4">
                            <a
                                className="full-width text-center btn btn-bordered btn-bordered-design-color pointer d-flex flex-column align-items-center justify-content-center py-2"
                                // data-bs-toggle="modal" data-bs-target="#property_distances_directions"
                                onClick={handleShow}
                            >
                                <FontAwesomeIcon icon={farRoute} size={'2x'}/>
                                <p className="block-title mb-0">{t('property.distancesDirections')}</p>
                                <p className="hint-text small hidden-xs mb-0">{t('property.distancesDirectionsTo')}</p>
                            </a>
                            <CustomModal
                                modalName="property_distances_directions"
                                className="slide_right"
                                modalSize="lg"
                                closeModal={() => {
                                    handleClose();
                                }}
                                show={show}
                                Title={<h2 className="text-wrap text-left mt-0">{t('property.distancesDirections')}</h2>}
                            >
                                <ModalPois descAreaDistances={props.descAreaDistances} map_pois={props.map_pois}
                                           handleClose={handleClose} property_lat={property_lat}
                                           property_lng={property_lng}/>
                            </CustomModal>
                        </div>
                    </div>
                </div>
            </section>
        ;
    }

    return (
        Checkers.googleMapsSectionInit(googleMapShow, property_lat, property_lng) &&
        <section ref={myRef}>
            <section id="map" className="bg-master-lightest" style={{height: 365}}>
                <div className={container + " no-padding no-overflow h-100"}>
                    {viewPortResult[0]}
                </div>
            </section>
            {viewPortResult[1]}
        </section>
    );
}
